import { ICustomer } from "../../../../context/CustomerProvider";

export const getGauntletAccountName = (customer: ICustomer): string =>
  customer?.intercom?.custom_attributes?.["Gauntlet Account Name"]?.split("gau")[0] || "";
